var SHOPIFY_DOMAIN='fuel-first.co.za';
var STOREFRONT_TOKEN='80cc8c6e33562b273068d6d33234df0e';
var STORE_URL='https://fuel-first.co.za';

var S={
  scr:0,
  name:'',lname:'',email:'',wt:'',wu:'kg',age:'',gen:'',
  sport:'',goal:'',rg:'',
  gpx:null,dp:'',dc:'',elev:'',
  tH:3,tM:0,pace:'',spd:'',
  wx:'',sw:'',fp:[],cf:'',dt:[],st:'',
  brands:{}
};

var CAT={
  gel:[
    {vendor:'GU',name:'Roctane Ultra Energy Gel',handle:'gu-roctane-gel',carbs:21},
    {vendor:'GU',name:'Energy Gel',handle:'gu-gel',carbs:22},
    {vendor:'Named Sport',name:'Race Fuel Gel',handle:'named-sport-race-fuel',carbs:26},
    {vendor:'Named Sport',name:'Isotonic Power Gel',handle:'named-sport-isotonic-power-gel',carbs:22},
    {vendor:'32Gi',name:'Sports Gel',handle:'32gi-gels',carbs:22},
    {vendor:'Enduren',name:'Endurance Energy Gel',handle:'enduren-energy-gel',carbs:20}
  ],
  chews:[
    {vendor:'GU',name:'Energy Chews',handle:'gu-energy-chews',carbs:22},
    {vendor:'Skratch Labs',name:'Sport Energy Chews',handle:'skratch-labs-energy-chews',carbs:20},
    {vendor:'32Gi',name:'Sports Chews',handle:'32gi-chews',carbs:22}
  ],
  bar:[
    {vendor:'Skratch Labs',name:'Anytime Energy Bar',handle:'skratch-labs-energy-bar',carbs:25},
    {vendor:'Named Sport',name:'Total Energy Fruit Bar',handle:'named-sport-total-energy',carbs:25},
    {vendor:'32Gi',name:'Race Pro Energy Bar',handle:'32gi-bar',carbs:22},
    {vendor:'Race Food',name:'Far Bar',handle:'farbar',carbs:18},
    {vendor:'Race Food',name:'Fast Bar',handle:'fastbar',carbs:11},
    {vendor:'Mama Alles',name:'Hiking Meal',handle:'mama-alles-hiking-meals',carbs:30}
  ],
  drink:[
    {vendor:'Open Fuel',name:'Ultra Fuel',handle:'open-fuel',carbs:58},
    {vendor:'Skratch Labs',name:'Super High Carb Drink Mix',handle:'skratch-labs-carb-drink-mix',carbs:90},
    {vendor:'32Gi',name:'Endure Sports Drink',handle:'32gi-endure-drink',carbs:30},
    {vendor:'Enduren',name:'Endurance Drink Mix',handle:'enduren-drink',carbs:28}
  ],
  electrolyte:[
    {vendor:'SaltWTR',name:'Electrolytes',handle:'saltwtr',carbs:0},
    {vendor:'REVIVE',name:'Daily Electrolytes',handle:'revive-daily-electrolytes',carbs:0},
    {vendor:'32Gi',name:'Cramp Assalt',handle:'32gi-cramp-assalt',carbs:0}
  ],
  recovery:[
    {vendor:'Wazoogles',name:'Superfood Protein Blend',handle:'wazoogles-protein-powder',carbs:10},
    {vendor:'32Gi',name:'Protein Bar',handle:'32gi-protein',carbs:20},
    {vendor:'Enduren',name:'Recover',handle:'enduren-recover',carbs:12}
  ],
  pre:[
    {vendor:'Named Sport',name:'Total Energy Fruit Bar',handle:'named-sport-total-energy',carbs:25},
    {vendor:'Skratch Labs',name:'Anytime Energy Bar',handle:'skratch-labs-energy-bar',carbs:25},
    {vendor:'32Gi',name:'Race Pro Energy Bar',handle:'32gi-bar',carbs:22},
    {vendor:'Race Food',name:'Far Bar',handle:'farbar',carbs:18}
  ]
};

var PROD_CACHE={};
var CACHE_LOADED=false;

async function loadProductCache(){
  if(CACHE_LOADED)return;
  var handles=[];
  Object.values(CAT).forEach(function(arr){arr.forEach(function(p){if(handles.indexOf(p.handle)<0)handles.push(p.handle);});});
  function toAlias(h){return 'p'+h.replace(/[^a-zA-Z0-9]/g,'_');}
  var fields=handles.map(function(h){
    return toAlias(h)+': productByHandle(handle:"'+h+'"){featuredImage{url}variants(first:20){edges{node{id availableForSale priceV2{amount}}}}}';
  }).join('\n');
  try{
    var res=await fetch('https://'+SHOPIFY_DOMAIN+'/api/2024-10/graphql.json',{
      method:'POST',headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':STOREFRONT_TOKEN},
      body:JSON.stringify({query:'{'+fields+'}'})
    });
    var data=await res.json();
    if(data.errors){console.warn('GraphQL errors',data.errors);}
    handles.forEach(function(h){
      var d=data.data&&data.data[toAlias(h)];
      if(d){
        var variants=(d.variants&&d.variants.edges)||[];
        var best=null;
        variants.forEach(function(e){
          var v=e.node;var price=parseFloat(v.priceV2.amount);
          if(v.availableForSale){if(!best||price<best.price){best={id:v.id,price:price,available:true};}}
        });
        if(!best&&variants.length){var v=variants[0].node;best={id:v.id,price:parseFloat(v.priceV2.amount),available:v.availableForSale};}
        PROD_CACHE[h]={
          img:d.featuredImage?d.featuredImage.url:null,
          variantNumId:best?best.id.split('/').pop():null,
          available:best?best.available:false,
          price:best?best.price:0
        };
      }
    });
    CACHE_LOADED=true;
  }catch(e){console.warn('Product cache load failed',e);}
}

function fmtM(m){var h=Math.floor(m/60),mn=Math.round(m%60);return h>0?h+'h '+String(mn).padStart(2,'0')+'m':mn+'m';}
function cap(s){return s?s[0].toUpperCase()+s.slice(1):'';}
function dist(){return parseFloat(S.dp==='custom'?S.dc:S.dp)||0;}
function durM(){return S.tH*60+S.tM;}
function kgW(){var w=parseFloat(S.wt)||70;return S.wu==='lbs'?w*0.453592:w;}
function sportLabel(){return({trail_run:'Trail Running',road_run:'Road Running',cycling:'Road Cycling',mtb:'Mountain Biking',tri:'Triathlon',hiking:'Hiking'})[S.sport]||'';}
function wantsGels(){return S.fp.indexOf('gels')>=0||S.fp.indexOf('liquid_gels')>=0;}
function wantsChews(){return S.fp.indexOf('chews')>=0;}
function wantsBars(){return S.fp.indexOf('bars')>=0||S.fp.indexOf('real_food')>=0;}
function wantsDrink(){return S.fp.indexOf('liquid')>=0;}
function wantsSolids(){return wantsGels()||wantsChews()||wantsBars();}
function scrollCard(){var c=document.querySelector('.ff-card');if(c)window.scrollTo({top:c.getBoundingClientRect().top+window.pageYOffset-24,behavior:'smooth'});}
function isAvail(handle){var c=PROD_CACHE[handle];return c?!!c.available:true;}
function firstAvail(cat){var pool=CAT[cat]||[];for(var i=0;i<pool.length;i++){if(isAvail(pool[i].handle))return pool[i];}return pool[0]||null;}

function subscribeCustomer(email,first,last){
  if(!email)return;
  try{
    var pw=Math.random().toString(36).slice(2)+Math.random().toString(36).slice(2);
    var mutation='mutation{customerCreate(input:{email:'+JSON.stringify(email)+',firstName:'+JSON.stringify(first||'')+',lastName:'+JSON.stringify(last||'')+',acceptsMarketing:true,password:'+JSON.stringify(pw)+'}){customer{id}userErrors{field message}}}';
    fetch('https://'+SHOPIFY_DOMAIN+'/api/2024-10/graphql.json',{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':STOREFRONT_TOKEN},
      body:JSON.stringify({query:mutation})
    }).catch(function(){});
  }catch(e){}
  return;
}
function subscribeCustomerOLD(email,first,last){
  if(!email)return;
  try{
    var fd=new FormData();
    fd.append('form_type','customer');
    fd.append('utf8','\u2713');
    fd.append('contact[email]',email);
    fd.append('contact[first_name]',first||'');
    fd.append('contact[last_name]',last||'');
    fd.append('contact[tags]','newsletter,fuel-first,planner');
    fetch('/contact',{method:'POST',body:fd,credentials:'same-origin'}).catch(function(){});
  }catch(e){}
}

var gpxData=null;
function handleDragOver(e){e.preventDefault();e.currentTarget.classList.add('drag-over');}
function handleDrop(e){e.preventDefault();e.currentTarget.classList.remove('drag-over');var f=e.dataTransfer.files[0];if(f&&f.name.endsWith('.gpx'))parseGPX(f);}
function loadGPX(e){var f=e.target.files[0];if(f)parseGPX(f);}
function parseGPX(file){
  var reader=new FileReader();
  reader.onload=function(e){
    var xml=new DOMParser().parseFromString(e.target.result,'text/xml');
    var pts=Array.from(xml.querySelectorAll('trkpt'));
    if(!pts.length){alert('Could not read GPX file');return;}
    var points=pts.map(function(p){return{lat:parseFloat(p.getAttribute('lat')),lon:parseFloat(p.getAttribute('lon')),ele:parseFloat(p.querySelector('ele')?.textContent||0),time:p.querySelector('time')?.textContent||null};});
    var dist=0,climb=0,descent=0;
    for(var i=1;i<points.length;i++){dist+=haversine(points[i-1],points[i]);var d=points[i].ele-points[i-1].ele;if(d>0)climb+=d;else descent+=Math.abs(d);}
    var elev=sampleArr(points.map(function(p){return p.ele;}),80);
    var estMins=0;
    if(points[0].time&&points[points.length-1].time){estMins=(new Date(points[points.length-1].time)-new Date(points[0].time))/60000;}
    else{estMins=(dist/1000/5)*60+(climb/10);}
    gpxData={name:file.name.replace('.gpx',''),distKm:Math.round(dist/100)/10,climbM:Math.round(climb),descentM:Math.round(descent),estMins:Math.round(estMins),elev:elev};
    S.elev=String(Math.round(climb));
    if(gpxData.distKm)S.dp='custom',S.dc=String(gpxData.distKm);
    var h=Math.floor(gpxData.estMins/60),mn=Math.round(gpxData.estMins%60);S.tH=h;S.tM=mn;
    render();
  };reader.readAsText(file);
}
function haversine(p1,p2){var R=6371000,dLat=(p2.lat-p1.lat)*Math.PI/180,dLon=(p2.lon-p1.lon)*Math.PI/180;var a=Math.sin(dLat/2)**2+Math.cos(p1.lat*Math.PI/180)*Math.cos(p2.lat*Math.PI/180)*Math.sin(dLon/2)**2;return R*2*Math.atan2(Math.sqrt(a),Math.sqrt(1-a));}
function sampleArr(arr,n){if(arr.length<=n)return arr;return Array.from({length:n},function(_,i){return arr[Math.floor(i*arr.length/n)];});}
function drawElev(elev){
  var canvas=document.getElementById('elev-canvas');if(!canvas)return;
  var W=canvas.offsetWidth*window.devicePixelRatio||600,H=128;
  canvas.width=W;canvas.height=H;
  var c=canvas.getContext('2d'),mn=Math.min.apply(null,elev),mx=Math.max.apply(null,elev),range=mx-mn||1;
  var grad=c.createLinearGradient(0,0,0,H);grad.addColorStop(0,'rgba(192,57,43,0.35)');grad.addColorStop(1,'rgba(192,57,43,0.02)');
  c.beginPath();elev.forEach(function(e,i){var x=(i/(elev.length-1))*W,y=H-((e-mn)/range)*(H*0.8)-H*0.1;i===0?c.moveTo(x,y):c.lineTo(x,y);});
  c.lineTo(W,H);c.lineTo(0,H);c.closePath();c.fillStyle=grad;c.fill();
  c.beginPath();elev.forEach(function(e,i){var x=(i/(elev.length-1))*W,y=H-((e-mn)/range)*(H*0.8)-H*0.1;i===0?c.moveTo(x,y):c.lineTo(x,y);});
  c.strokeStyle='#C0392B';c.lineWidth=2;c.stroke();
}
function clearGPX(){gpxData=null;S.dp='';S.dc='';S.elev='';S.tH=3;S.tM=0;render();}

function flow(){
  var f=['profile','sport','goal'];
  if(S.goal==='racing')f.push('raceGoal');
  f.push('gpx','distance','elevation','time','conditions','sweat','fuelPrefs','brands','caffeine','dietary','stomach','results');
  return f;
}
function prg(){return Math.round((S.scr/(flow().length-1))*100);}
function nxt(){if(S.scr<flow().length-1){S.scr++;render();}}
function bk(){if(S.scr>0){S.scr--;render();}}
function setWu(v){saveProfile();S.wu=v;render();}
function setGen(v){saveProfile();S.gen=v;render();}
function setSport(v){S.sport=v;render();}
function setGoal(v){S.goal=v;if(v==='training')S.rg='';render();}
function setRg(v){S.rg=v;render();}
function setDp(v){S.dp=v;S.dc='';render();}
function setWx(v){S.wx=v;render();}
function setSw(v){S.sw=v;render();}
function setCf(v){S.cf=v;render();}
function setSt(v){S.st=v;render();}
function togFp(v){S.fp=S.fp.filter(function(x){return x!='none';});var i=S.fp.indexOf(v);if(i>=0)S.fp.splice(i,1);else S.fp.push(v);render();}
function togDt(v,ex){if(ex){S.dt=[v];}else{S.dt=S.dt.filter(function(x){return x!='none';});var i=S.dt.indexOf(v);if(i>=0)S.dt.splice(i,1);else S.dt.push(v);}render();}
function adjH(d){S.tH=Math.max(0,Math.min(72,S.tH+d));render();}
function adjM(d){var t=S.tH*60+S.tM+d;if(t<0)t=0;S.tH=Math.floor(t/60);S.tM=t%60;render();}
function calcFromPace(){
  var d=dist();if(!d)return;
  var cy=S.sport==='cycling'||S.sport==='mtb',m=0;
  if(cy){var sp=parseFloat(S.spd);if(sp>0)m=(d/sp)*60;}
  else{var r=(S.pace||'').trim();if(r.indexOf(':')>=0){var pp=r.split(':');m=(parseInt(pp[0])+(parseInt(pp[1]||0)/60))*d;}else{var pm=parseFloat(r);if(pm>0)m=pm*d;}}
  if(m>0){S.tH=Math.floor(m/60);S.tM=Math.round(m%60);var el=document.querySelector('.ff-time-display');if(el)el.innerHTML=String(S.tH).padStart(2,'0')+'<span class="ff-time-sep">:</span>'+String(S.tM).padStart(2,'0');}
}
function saveProfile(){
  var em=document.getElementById('p-em'),nm=document.getElementById('p-nm'),ln=document.getElementById('p-ln'),wt=document.getElementById('p-wt'),ag=document.getElementById('p-ag');
  if(em)S.email=em.value;if(nm)S.name=nm.value;if(ln)S.lname=ln.value;if(wt)S.wt=wt.value;if(ag)S.age=ag.value;
}
function submitProfile(){
  saveProfile();
  if(!S.email||!S.name||!S.wt){show('p-notice','Email, first name and weight are required.','err');return;}
  subscribeCustomer(S.email,S.name,S.lname||'');
  nxt();
}
function show(id,msg,type){var el=document.getElementById(id);if(!el)return;el.textContent=msg;el.style.display='block';el.className=type==='err'?'ff-notice-err':'ff-notice';}
function dpOpts(){
  var run=[{l:'10K',v:'10'},{l:'Half Marathon',v:'21.1',s:'21.1km'},{l:'Marathon',v:'42.2',s:'42.2km'},{l:'50K',v:'50'},{l:'100K',v:'100'},{l:'Custom',v:'custom'}];
  var cyc=[{l:'50km',v:'50'},{l:'80km',v:'80'},{l:'100km',v:'100'},{l:'160km',v:'160'},{l:'Custom',v:'custom'}];
  var tri=[{l:'Sprint',v:'25.75',s:'750m+20+5'},{l:'Olympic',v:'51.5',s:'1.5+40+10'},{l:'70.3',v:'113',s:'Half IM'},{l:'140.6',v:'226',s:'Full IM'},{l:'Custom',v:'custom'}];
  var hik=[{l:'10km',v:'10'},{l:'20km',v:'20'},{l:'30km',v:'30'},{l:'Multi-day',v:'50'},{l:'Custom',v:'custom'}];
  if(S.sport==='cycling'||S.sport==='mtb')return cyc;
  if(S.sport==='tri')return tri;
  if(S.sport==='hiking')return hik;
  return run;
}
function topBar(label){
  return '<div class="ff-topbar">'+
    (S.scr>0?'<button class="ff-bk" onclick="bk()">&#8592;</button>':'<span style="width:24px"></span>')+
    '<span class="ff-topbar-label">'+(label||'The Planner')+'</span>'+
    '<span style="width:24px"></span></div>'+
    '<div class="ff-prog"><span class="ff-prog-fill" style="width:'+prg()+'%"></span></div>';
}

function Sprofile(){
  return topBar('Your Profile')+
  '<div class="ff-sec">'+
  '<span class="ff-q">Tell us about you</span>'+
  '<span class="ff-hint">We personalise your plan to your body and goals. Your email gets you a copy and joins you to the list.</span>'+
  '<div class="ff-fields">'+
    '<div class="ff-f"><label>Email Address *</label><input id="p-em" class="ff-fi" type="email" placeholder="you@example.com" value="'+(S.email||'')+'"></div>'+
    '<div class="ff-fr">'+
      '<div class="ff-f"><label>First Name *</label><input id="p-nm" class="ff-fi" type="text" placeholder="e.g. Alex" value="'+(S.name||'')+'"></div>'+
      '<div class="ff-f"><label>Surname</label><input id="p-ln" class="ff-fi" type="text" placeholder="Optional" value="'+(S.lname||'')+'"></div>'+
    '</div>'+
    '<div class="ff-fr">'+
      '<div class="ff-f"><label>Weight *</label>'+
        '<div class="ff-ur"><div class="ff-f"><input id="p-wt" class="ff-fi" type="number" placeholder="70" value="'+(S.wt||'')+'" min="30" max="250"></div>'+
        '<div class="ff-ut"><button class="'+(S.wu==='kg'?'on':'')+'" onclick="setWu(\'kg\')">kg</button><button class="'+(S.wu==='lbs'?'on':'')+'" onclick="setWu(\'lbs\')">lbs</button></div></div>'+
      '</div>'+
      '<div class="ff-f"><label>Age</label><input id="p-ag" class="ff-fi" type="number" placeholder="35" value="'+(S.age||'')+'" min="16" max="80"></div>'+
    '</div>'+
    '<div class="ff-f"><label>Gender</label><div class="ff-gbr">'+
      '<button class="ff-gb'+(S.gen==='male'?' on':'')+'" onclick="setGen(\'male\')">Male</button>'+
      '<button class="ff-gb'+(S.gen==='female'?' on':'')+'" onclick="setGen(\'female\')">Female</button>'+
      '<button class="ff-gb'+(S.gen==='other'?' on':'')+'" onclick="setGen(\'other\')">Other</button>'+
    '</div></div>'+
    '<div id="p-notice" style="display:none"></div>'+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="saveProfile();submitProfile()">Continue &rarr;</button></div>';
}
function Ssport(){
  var opts=[
    {v:'trail_run',l:'Trail Running',i:'\uD83C\uDFD4\uFE0F'},
    {v:'road_run',l:'Road Running',i:'\uD83C\uDFC3'},
    {v:'cycling',l:'Road Cycling',i:'\uD83D\uDEB4'},
    {v:'mtb',l:'Mountain Biking',i:'\uD83D\uDEB5'},
    {v:'tri',l:'Triathlon',i:'\uD83C\uDFCA'},
    {v:'hiking',l:'Hiking',i:'\uD83E\uDD7E'}
  ];
  return topBar('Activity')+
  '<div class="ff-sec"><span class="ff-q">What are you planning?</span>'+
  '<div class="ff-g2" style="margin-top:20px">'+
  opts.map(function(o){return'<button class="ff-opt ff-opt-center'+(S.sport===o.v?' on':'')+'" onclick="setSport(\''+o.v+'\')"><span class="ff-opt-icon">'+o.i+'</span>'+o.l+'</button>';}).join('')+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.sport)nxt()">Continue &rarr;</button></div>';
}
function Sgoal(){
  return topBar('Activity Goal')+
  '<div class="ff-sec"><span class="ff-q">Racing or training?</span>'+
  '<div class="ff-g2" style="margin-top:20px">'+
  '<button class="ff-opt ff-opt-center'+(S.goal==='racing'?' on':'')+'" onclick="setGoal(\'racing\')">\uD83C\uDFC6<span class="ff-opt-sub">Racing</span></button>'+
  '<button class="ff-opt ff-opt-center'+(S.goal==='training'?' on':'')+'" onclick="setGoal(\'training\')">\uD83D\uDCAA<span class="ff-opt-sub">Training</span></button>'+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.goal)nxt()">Continue &rarr;</button></div>';
}
function SraceGoal(){
  var opts=[
    {v:'compete',l:'I want to compete',s:'Podium or category result'},
    {v:'improve',l:'I want to improve my time',s:'Going for a personal best'},
    {v:'finish',l:'I want to finish',s:'Completion is the goal'}
  ];
  return topBar('Race Goal')+
  '<div class="ff-sec"><span class="ff-q">What is your race goal?</span>'+
  '<div class="ff-opts" style="margin-top:20px">'+
  opts.map(function(o){return'<button class="ff-opt'+(S.rg===o.v?' on':'')+'" onclick="setRg(\''+o.v+'\')">'+o.l+'<span class="ff-opt-sub">'+o.s+'</span></button>';}).join('')+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.rg)nxt()">Continue &rarr;</button></div>';
}
function Sgpx(){
  var loaded=gpxData!==null;
  return topBar('Route Upload')+
  '<div class="ff-sec"><span class="ff-q">Got a GPX file?</span>'+
  '<span class="ff-hint">Drop your route from Strava, Garmin or Komoot for elevation-adjusted targets. Or skip and enter your details manually.</span>'+
  (!loaded?
    '<div class="ff-gpx-drop" onclick="document.getElementById(\'gpx-in\').click()" ondragover="handleDragOver(event)" ondrop="handleDrop(event)">'+
      '<div class="ff-gpx-icon">\uD83D\uDCCD</div>'+
      '<div class="ff-gpx-title">Upload GPX File</div>'+
      '<div class="ff-gpx-sub">Tap to browse. Strava, Garmin, Komoot, Suunto</div>'+
    '</div>'+
    '<input type="file" id="gpx-in" accept=".gpx" style="display:none" onchange="loadGPX(event)">':
    '<div class="ff-gpx-loaded">'+
      '<div style="font-size:24px">\uD83D\uDCCD</div>'+
      '<div style="flex:1">'+
        '<div class="ff-gpx-loaded-name">'+gpxData.name+'</div>'+
        '<div class="ff-gpx-loaded-meta">'+gpxData.distKm+'km &middot; &uarr;'+gpxData.climbM+'m &middot; ~'+fmtM(gpxData.estMins)+'</div>'+
      '</div>'+
      '<span class="ff-gpx-clear" onclick="clearGPX()">&#10005;</span>'+
    '</div>'+
    '<div class="ff-elev-chart-wrap" style="margin-top:12px">'+
      '<div class="ff-elev-chart-label">Elevation Profile</div>'+
      '<canvas class="ff-elev-canvas" id="elev-canvas"></canvas>'+
    '</div>'
  )+
  '<a class="ff-skip-link" onclick="nxt()">Skip and enter details manually &rarr;</a>'+
  '</div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="nxt()">'+(loaded?'Use This Route &rarr;':'Skip &rarr;')+'</button></div>';
}
function Sdistance(){
  var opts=dpOpts(),showC=S.dp==='custom';
  return topBar('Distance')+
  '<div class="ff-sec"><span class="ff-q">What distance?</span>'+
  '<span class="ff-hint">Select a preset or enter your own.'+(gpxData?' Your GPX distance has been pre-filled.':'')+'</span>'+
  '<div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:16px">'+
  opts.map(function(o){return'<button class="ff-opt'+(S.dp===o.v?' on':'')+'" onclick="setDp(\''+o.v+'\')">'+o.l+(o.s?'<span class="ff-opt-sub">'+o.s+'</span>':'')+'</button>';}).join('')+
  '</div>'+
  (showC?'<div class="ff-f" style="margin-top:12px"><label>Distance (km)</label><input id="p-dc" class="ff-fi" type="number" placeholder="e.g. 65" value="'+(S.dc||'')+'" min="1" oninput="S.dc=this.value"></div>':'')+
  '</div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(dist())nxt()">Continue &rarr;</button></div>';
}
function Selevation(){
  return topBar('Elevation')+
  '<div class="ff-sec"><span class="ff-q">Elevation gain?</span>'+
  '<span class="ff-hint">Enter 0 for flat routes. Every 500m of climbing adds roughly 5% to carb and fluid targets.'+(gpxData?' Pre-filled from your GPX.':'')+'</span>'+
  '<div class="ff-elev-center">'+
  '<input class="ff-elev-input" type="number" placeholder="0" value="'+(S.elev||'')+'" min="0" max="12000" oninput="S.elev=this.value">'+
  '<span class="ff-elev-unit">metres of climbing</span>'+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(!S.elev)S.elev=\'0\';nxt()">Continue &rarr;</button></div>';
}
function Stime(){
  var cy=S.sport==='cycling'||S.sport==='mtb';
  return topBar('Finish Time')+
  '<div class="ff-sec"><span class="ff-q">Estimated finish time?</span>'+
  (gpxData?'<span class="ff-hint">Pre-filled from your GPX. Adjust if needed.</span>':'<span class="ff-hint">Enter a pace or speed to auto-calculate, or set the time directly.</span>')+
  '<div style="text-align:center;padding:16px 0">'+
  '<span class="ff-time-display">'+String(S.tH).padStart(2,'0')+'<span class="ff-time-sep">:</span>'+String(S.tM).padStart(2,'0')+'</span>'+
  '<div class="ff-steppers">'+
    '<div class="ff-stepper"><button class="ff-step-btn" onclick="adjH(-1)">&#8722;</button><span class="ff-step-label">hrs</span><button class="ff-step-btn" onclick="adjH(1)">+</button></div>'+
    '<div class="ff-stepper"><button class="ff-step-btn" onclick="adjM(-15)">&#8722;</button><span class="ff-step-label">min</span><button class="ff-step-btn" onclick="adjM(15)">+</button></div>'+
  '</div></div>'+
  '<div class="ff-pace-wrap">'+
    '<label>'+(cy?'Avg Speed (km/h)':'Avg Pace (min/km, e.g. 5:30)')+'</label>'+
    '<input class="ff-pace-input" type="text" placeholder="'+(cy?'e.g. 28':'e.g. 5:30')+'" value="'+(cy?S.spd:S.pace)+'" oninput="'+(cy?'S.spd':'S.pace')+'=this.value;calcFromPace()">'+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(durM()>0)nxt()">Continue &rarr;</button></div>';
}
function Sconditions(){
  var opts=[{v:'cold',l:'Cold',s:'Below 10C'},{v:'mild',l:'Mild',s:'10 to 24C'},{v:'hot',l:'Hot',s:'Above 24C'}];
  return topBar('Conditions')+
  '<div class="ff-sec"><span class="ff-q">Expected conditions?</span>'+
  '<span class="ff-hint">Temperature and humidity affect your fluid and sodium needs significantly.</span>'+
  '<div class="ff-g3" style="margin-top:20px">'+
  opts.map(function(o){return'<button class="ff-opt ff-opt-center'+(S.wx===o.v?' on':'')+'" onclick="setWx(\''+o.v+'\')">'+o.l+'<span class="ff-opt-sub">'+o.s+'</span></button>';}).join('')+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.wx)nxt()">Continue &rarr;</button></div>';
}
function Ssweat(){
  var opts=[{v:'low',l:'I barely sweat'},{v:'moderate',l:'I sweat moderately'},{v:'high',l:'I sweat heavily'}];
  return topBar('Sweat Rate')+
  '<div class="ff-sec"><span class="ff-q">How much do you sweat?</span>'+
  '<span class="ff-hint">Salty sweat stains on kit usually means a high sweat rate. Affects fluid and sodium targets.</span>'+
  '<div class="ff-opts" style="margin-top:20px">'+
  opts.map(function(o){return'<button class="ff-opt'+(S.sw===o.v?' on':'')+'" onclick="setSw(\''+o.v+'\')">'+o.l+'</button>';}).join('')+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.sw)nxt()">Continue &rarr;</button></div>';
}
function SfuelPrefs(){
  var opts=[
    {v:'liquid',l:'Liquid Carbs',s:'Drink mix and fluid carbs',i:'\uD83D\uDCA7'},
    {v:'gels',l:'Gels',s:'Fast-release energy gels',i:'\u26A1'},
    {v:'liquid_gels',l:'Liquid Gels',s:'Isotonic / no-water gels',i:'\uD83E\uDED9'},
    {v:'chews',l:'Chews',s:'Chewable carb blocks',i:'\uD83C\uDF6C'},
    {v:'bars',l:'Energy Bars',s:'Solid bars for longer efforts',i:'\uD83C\uDF6B'},
    {v:'real_food',l:'Real Food',s:'Meals, snacks, hiking food',i:'\uD83E\uDD59'}
  ];
  return topBar('Fuel Preferences')+
  '<div class="ff-sec"><span class="ff-q">What do you like to use?</span>'+
  '<span class="ff-hint">Select all that apply. We build your plan around a small kit of what you pick, and always include hydration.</span>'+
  '<div class="ff-g2" style="margin-top:20px">'+
  opts.map(function(o){return'<button class="ff-opt'+(S.fp.indexOf(o.v)>=0?' on':'')+'" onclick="togFp(\''+o.v+'\')"><span class="ff-ck">&#10003;</span><span class="ff-opt-icon">'+o.i+'</span>'+o.l+'<span class="ff-opt-sub">'+o.s+'</span></button>';}).join('')+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.fp.length)nxt()">Continue &rarr;</button></div>';
}
function Sbrands(){
  var brands=brandList();
  var chips=brands.map(function(b){
    var on=!!S.brands[b];
    return '<button class="ff-opt ff-opt-center'+(on?' on':'')+'" onclick="togBrand(\''+b+'\')"><span class="ff-ck">\u2713</span>'+b+'</button>';
  }).join('');
  return topBar('Brands')+
  '<div class="ff-sec"><span class="ff-q">Preferred brands?</span>'+
  '<span class="ff-hint">Optional. Pick the brands you like and we build the mix around them, with the odd item from others to keep it varied. Leave blank and we choose for you.</span>'+
  '<div class="ff-g2" style="margin-top:18px">'+chips+'</div>'+
  '</div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="nxt()">'+(Object.keys(S.brands).length?'Continue':'Skip, choose for me')+' &rarr;</button></div>';
}
function Scaffeine(){
  return topBar('Caffeine')+
  '<div class="ff-sec"><span class="ff-q">Open to caffeinated products?</span>'+
  '<span class="ff-hint">Most effective in the back half of long efforts. Peaks 45 to 60 min after taking it.</span>'+
  '<div class="ff-g2" style="margin-top:20px">'+
  '<button class="ff-opt ff-opt-center'+(S.cf==='yes'?' on':'')+'" onclick="setCf(\'yes\')">Yes</button>'+
  '<button class="ff-opt ff-opt-center'+(S.cf==='no'?' on':'')+'" onclick="setCf(\'no\')">No</button>'+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.cf)nxt()">Continue &rarr;</button></div>';
}
function Sdietary(){
  var opts=[{v:'gluten',l:'Gluten Free',ex:false},{v:'nut',l:'Nut / Peanut Free',ex:false},{v:'vegan',l:'Vegan',ex:false},{v:'none',l:'No restrictions',ex:true}];
  return topBar('Dietary')+
  '<div class="ff-sec"><span class="ff-q">Any dietary requirements?</span>'+
  '<span class="ff-hint">Select all that apply. We flag products to verify before race day.</span>'+
  '<div class="ff-g2" style="margin-top:20px">'+
  opts.map(function(o){return'<button class="ff-opt'+(S.dt.indexOf(o.v)>=0?' on':'')+'" onclick="togDt(\''+o.v+'\','+o.ex+')"><span class="ff-ck">&#10003;</span>'+o.l+'</button>';}).join('')+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.dt.length)nxt()">Continue &rarr;</button></div>';
}
function Sstomach(){
  var opts=[
    {v:'robust',l:'I can eat anything',s:'Never had GI issues on the move'},
    {v:'occasional',l:'Occasional issues',s:'Cramps or nausea sometimes'},
    {v:'sensitive',l:'Frequently problematic',s:'GI is a recurring challenge'}
  ];
  return topBar('Gut')+
  '<div class="ff-sec"><span class="ff-q">How is your stomach?</span>'+
  '<span class="ff-hint">Affects carb targets and what we recommend. A sensitive gut needs lower targets and simpler products.</span>'+
  '<div class="ff-opts" style="margin-top:20px">'+
  opts.map(function(o){return'<button class="ff-opt'+(S.st===o.v?' on':'')+'" onclick="setSt(\''+o.v+'\')">'+o.l+'<span class="ff-opt-sub">'+o.s+'</span></button>';}).join('')+
  '</div></div>'+
  '<div class="ff-cta-wrap"><button class="ff-cta" onclick="if(S.st)nxt()">Build My Plan &rarr;</button></div>';
}

function compute(){
  var d=dist(),dm=durM(),wt=kgW(),el=parseFloat(S.elev)||0;
  var hrs=dm/60,cp=0;
  if(dm<45)cp=0;
  else if(dm<60)cp=20;
  else if(dm<90)cp=45;
  else if(dm<120)cp=60;
  else if(dm<180)cp=72;
  else cp=82;
  cp=Math.min(cp+Math.floor(el/500)*5,90);
  if(S.rg==='compete')cp=Math.min(Math.round(cp*1.05),90);
  else if(S.rg==='finish'||S.goal==='training')cp=Math.round(cp*0.93);
  if(S.st==='sensitive')cp=Math.min(cp,55);
  else if(S.st==='occasional')cp=Math.min(cp,72);
  var fl=wt>90?750:wt>75?680:600;
  if(S.sw==='high')fl+=200;else if(S.sw==='low')fl-=100;
  if(S.wx==='hot')fl+=200;else if(S.wx==='cold')fl-=100;
  fl=Math.max(350,Math.min(fl,800));
  var na='400 to 600';
  if(S.sw==='high'&&S.wx==='hot')na='700 to 1000';
  else if(S.sw==='high'||S.wx==='hot')na='500 to 700';
  else if(S.sw==='low'&&S.wx==='cold')na='200 to 350';
  var tc=Math.round(cp*hrs);
  return{cp:cp,tc:tc,fl:fl,na:na,dm:dm,d:d,el:el,hrs:hrs,wt:wt};
}
function pickerCats(){var c=[];if(wantsDrink())c.push('drink');if(wantsGels())c.push('gel');if(wantsChews())c.push('chews');if(wantsBars())c.push('bar');return c;}
function poolAvail(cat){var pool=(CAT[cat]||[]).filter(function(p){return isAvail(p.handle);});return pool.length?pool:(CAT[cat]||[]);}
function togBrand(b){if(S.brands[b])delete S.brands[b];else S.brands[b]=true;render();}
function brandList(){var seen={},order=[];pickerCats().concat(['electrolyte','recovery']).forEach(function(cat){poolAvail(cat).forEach(function(p){if(!seen[p.vendor]){seen[p.vendor]=true;order.push(p.vendor);}});});return order;}
function chooseDrinkFrom(pool,cp){var aim=wantsSolids()?55:cp;return pool.reduce(function(b,p){return Math.abs(p.carbs-aim)<Math.abs(b.carbs-aim)?p:b;});}

// Preferred brands, not only brands. Preferred items are weighted heavily, with one
// non-preferred wildcard mixed in so it never gets monotonous. No brands chosen = use all.
function brandPool(cat){
  var all=poolAvail(cat);
  if(!Object.keys(S.brands).length)return all;
  var pref=all.filter(function(p){return S.brands[p.vendor];});
  var other=all.filter(function(p){return !S.brands[p.vendor];});
  if(!pref.length)return all;
  var pool=pref.concat(pref);
  if(other.length)pool.push(other[0]);
  return pool;
}
function firstAvailPref(cat){
  var pool=poolAvail(cat);
  if(Object.keys(S.brands).length){var pr=pool.filter(function(p){return S.brands[p.vendor];});if(pr.length)return pr[0];}
  return pool[0]||null;
}

function selectKit(plan){
  var gelPool=wantsGels()?brandPool('gel'):[];
  var chewPool=wantsChews()?brandPool('chews'):[];
  var barPool=wantsBars()?brandPool('bar'):[];
  var drink=null;
  if(wantsDrink()){
    var dAll=poolAvail('drink');
    var dPref=Object.keys(S.brands).length?dAll.filter(function(p){return S.brands[p.vendor];}):[];
    var dSet=dPref.length?dPref:dAll;
    if(dSet.length)drink=chooseDrinkFrom(dSet,plan.cp);
  }
  return{drink:drink,gelPool:gelPool,chewPool:chewPool,barPool:barPool,
    elec:firstAvailPref('electrolyte'),recovery:firstAvailPref('recovery'),pre:firstAvailPref('pre')};
}

// Phase-aware timeline. Early leans bars/solids, late leans gels, caffeine concentrates late.
function buildTimeline(plan,kit){
  var hoursCeil=Math.max(1,Math.ceil(plan.hrs)),cp=plan.cp,drink=kit.drink;
  var gel=kit.gelPool||[],chew=kit.chewPool||[],bar=kit.barPool||[];
  function firstNonEmpty(order){for(var i=0;i<order.length;i++){if(order[i]&&order[i].length)return order[i];}return null;}
  var poolEarly=firstNonEmpty([bar,chew,gel]),poolMid=firstNonEmpty([chew,gel,bar]),poolLate=firstNonEmpty([gel,chew,bar]);
  var rot={early:0,mid:0,late:0};
  var hours=[];
  for(var h=1;h<=hoursCeil;h++){
    var frac=(h-0.5)/hoursCeil,phase;
    if(hoursCeil===1)phase='all';
    else if(hoursCeil===2)phase=(h===1?'early':'late');
    else phase=frac<0.34?'early':(frac>0.66?'late':'mid');
    var pkey=(phase==='all'?'early':phase);
    var pool=phase==='all'?firstNonEmpty([gel,chew,bar]):(phase==='early'?poolEarly:phase==='mid'?poolMid:poolLate);
    if(!pool||!pool.length)pool=firstNonEmpty([gel,chew,bar]);
    var items=[],remaining=cp;
    if(drink){items.push({p:drink,count:1});remaining-=drink.carbs;}
    if(pool&&pool.length){
      var prod=pool[rot[pkey]%pool.length];rot[pkey]++;
      if(!drink){var n0=Math.max(1,Math.round(cp/prod.carbs));items.push({p:prod,count:n0});}
      else if(remaining>5){var n=Math.max(1,Math.round(remaining/prod.carbs));items.push({p:prod,count:n});}
    } else if(drink&&remaining>20){var extra=Math.round(remaining/drink.carbs);if(extra>0)items[0].count+=extra;}
    var total=items.reduce(function(a,i){return a+i.count*i.p.carbs;},0);
    hours.push({h:h,phase:phase,items:items,total:total});
  }
  return hours;
}
function prodImg(p){
  var c=p?PROD_CACHE[p.handle]:null;
  if(c&&c.img)return '<img class="ff-rhythm-img" src="'+c.img+'" alt="'+p.name+'" loading="lazy">';
  return '<div class="ff-rhythm-imgph">\u26A1</div>';
}
var cartItems=[];
async function addToCartShopify(variantNumId,qty,btnId){
  var btn=document.getElementById(btnId);if(!btn)return;
  btn.classList.add('loading');btn.textContent='Adding\u2026';
  try{
    var r=await fetch(STORE_URL+'/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(variantNumId),quantity:qty}]})});
    if(r.ok){btn.classList.remove('loading');btn.classList.add('added');btn.textContent='\u2713 Added';setTimeout(function(){btn.classList.remove('added');btn.textContent='Add \u00d7'+qty;},2500);}
    else{throw new Error('ajax failed');}
  }catch(e){btn.classList.remove('loading');btn.textContent='Add \u00d7'+qty;window.open(STORE_URL+'/cart/'+variantNumId+':'+qty+'?storefront=true','_blank');}
}
function goToCart(){
  if(!cartItems.length)return;
  var parts=[];
  cartItems.forEach(function(i){var c=PROD_CACHE[i.handle];if(c&&c.variantNumId)parts.push(c.variantNumId+':'+i.qty);});
  if(parts.length){window.open(STORE_URL+'/cart/'+parts.join(',')+'?storefront=true','_blank');}
  else{window.open(STORE_URL+'/cart','_blank');}
}
function mergeShop(arr){
  var seen={},out=[];
  arr.forEach(function(i){if(!i)return;if(seen[i.handle]){seen[i.handle].qty+=i.qty;}else{seen[i.handle]={vendor:i.vendor,name:i.name,handle:i.handle,qty:i.qty};out.push(seen[i.handle]);}});
  return out;
}

function Sresults(){
  var plan=compute();
  var kit=selectKit(plan);
  var fn=S.name?S.name.split(' ')[0]:'Athlete';
  var dm=plan.dm,hrs=plan.hrs,hoursCeil=Math.max(1,Math.ceil(hrs));

  if(dm<45){
    return topBar('Your Plan')+
    '<div class="ff-sec">'+
    '<span class="ff-result-label">Fuel First. '+fn+'\'s Plan</span>'+
    '<span class="ff-result-heading">'+sportLabel()+'</span>'+
    '<span class="ff-result-meta">'+plan.d+'km &middot; '+fmtM(dm)+'</span>'+
    '<div class="ff-hydration-bar">\uD83D\uDCA7 <strong>Short session.</strong> Water is enough. Your glycogen stores cover an effort this short. Sip to thirst and have a normal meal within an hour or two of finishing.</div>'+
    '<div class="ff-cta-wrap"><a href="'+STORE_URL+'/collections/all" target="_blank" class="ff-shop-btn">Browse All Products &rarr;</a><button class="ff-rst" onclick="planReset()">Start a New Plan</button></div>'+
    '</div>';
  }

  var timeline=buildTimeline(plan,kit);
  var elecServings=dm>=90?Math.max(1,Math.floor(dm/90)):(dm>=60?1:0);
  var caff=S.cf==='yes'&&dm>=120;

  var shopRaw=[];
  timeline.forEach(function(hr){hr.items.forEach(function(it){shopRaw.push({vendor:it.p.vendor,name:it.p.name,handle:it.p.handle,qty:it.count});});});
  if(kit.elec&&elecServings>0)shopRaw.push({vendor:kit.elec.vendor,name:kit.elec.name,handle:kit.elec.handle,qty:elecServings});
  if(kit.pre&&dm>=90)shopRaw.push({vendor:kit.pre.vendor,name:kit.pre.name,handle:kit.pre.handle,qty:1});
  if(kit.recovery&&dm>=60)shopRaw.push({vendor:kit.recovery.vendor,name:kit.recovery.name,handle:kit.recovery.handle,qty:1});
  var shop=mergeShop(shopRaw);
  // On long efforts, real food and aid station snacks cover a share of carbs, so buy less.
  // Ramps from 0 at 5h to a 40% cap at 15h+. The hourly plan above stays at full intake.
  var aidFrac=dm>=300?Math.min(0.40,(dm-300)/60*0.04):0;
  if(aidFrac>0){shop=shop.map(function(i){return{vendor:i.vendor,name:i.name,handle:i.handle,qty:Math.max(1,Math.round(i.qty*(1-aidFrac)))};});}
  var aidPct=Math.round(aidFrac*100);
  cartItems=shop;

  var alerts=[];
  if(S.dt.indexOf('gluten')>=0)alerts.push('Gluten-free: verify all products before race day.');
  if(S.dt.indexOf('nut')>=0)alerts.push('Nut-free: check labels carefully. Cross-contamination risk in some products.');
  if(S.dt.indexOf('vegan')>=0)alerts.push('Vegan: most gels are fine, some bars contain dairy or honey.');
  if(S.wx==='hot'&&S.sw==='high')alerts.push('High heat plus heavy sweating: sodium and fluid are your top priority today.');
  if(plan.el>1500)alerts.push('Significant climbing ('+plan.el+'m): fuel steadily and use the climbs, where you are slower, to get food down.');
  if(plan.dm>300)alerts.push('5h plus effort: plan for flavour fatigue. Mix in real food and rotate flavours.');

  var phaseGroups=[];
  timeline.forEach(function(hr){
    var last=phaseGroups[phaseGroups.length-1];
    if(last&&last.key===hr.phase){last.hours.push(hr.h);last.allItems.push(hr.items);}
    else{phaseGroups.push({key:hr.phase,hours:[hr.h],items:hr.items,total:hr.total,allItems:[hr.items]});}
  });
  var phaseLabel={early:'Early',mid:'Middle',late:'Late',all:'Throughout'};
  function rangeTxt(a){var f=a[0],l=a[a.length-1];return f===l?('Hour '+f):('Hours '+f+' to '+l);}
  function itemRow(it){
    var inBottle=(kit.drink&&it.p.handle===kit.drink.handle);
    var sub=(it.count>1?it.count+' servings':'1 serving')+(inBottle?' in the bottle':'');
    return '<div class="ff-rhythm-item">'+prodImg(it.p)+
      '<div class="ff-rhythm-txt"><span class="ff-rhythm-brand">'+it.p.vendor+'</span><div class="ff-rhythm-name">'+it.p.name+'</div><div class="ff-rhythm-qty">'+sub+'</div></div>'+
      '<span class="ff-carb-chip">'+(it.count*it.p.carbs)+'g</span></div>';
  }
  var single=phaseGroups.length<=1;
  var rhythm=phaseGroups.map(function(g){
    var names={};g.allItems.forEach(function(items){items.forEach(function(it){if(!(kit.drink&&it.p.handle===kit.drink.handle))names[it.p.vendor+' '+it.p.name]=true;});});
    var distinct=Object.keys(names);
    var rotateNote=distinct.length>1?'<div class="ff-rhythm-qty" style="padding:2px 16px 12px">Rotating: '+distinct.join(', ')+'</div>':'';
    var head=single?'<span class="ff-rhythm-title">Each hour</span>':'<span class="ff-rhythm-title">'+phaseLabel[g.key]+' <span class="ff-phase-tag">'+rangeTxt(g.hours)+'</span></span>';
    return '<div class="ff-rhythm">'+
      '<div class="ff-rhythm-head">'+head+'<span class="ff-rhythm-target">target ~'+plan.cp+'g</span></div>'+
      g.items.map(itemRow).join('')+rotateNote+
      '<div class="ff-rhythm-total"><span>Hourly carbs</span><span class="v">'+g.total+'g</span></div>'+
    '</div>';
  }).join('');
  rhythm+='<p class="ff-repeat-note">'+(single?'Repeat this every hour for about <strong>'+hoursCeil+(hoursCeil===1?' hour':' hours')+'</strong>. ':'Your fuel shifts as the effort goes on: solids early while your gut is fresh, gels later when they go down easier. ')+'Sip fluid every 20 minutes, whether you feel thirsty or not.'+(caff?' Caffeine works best in the final third.':'')+'</p>';
  var aidNote='<div class="ff-aid-bar">\uD83C\uDFC1 <strong>At every aid station:</strong> refill your bottle, take water with your next gel, and restock your pockets for the section ahead. Do not skip a station just because you feel fine.</div>';

  var elecNote='';
  if(kit.elec&&elecServings>0){
    var ei=PROD_CACHE[kit.elec.handle];
    elecNote='<div class="ff-note-card">'+
      (ei&&ei.img?'<img class="ff-note-img" src="'+ei.img+'" alt="'+kit.elec.name+'" loading="lazy">':'<div class="ff-note-imgph">\uD83E\uDDC2</div>')+
      '<div class="ff-note-txt">'+
        '<span class="ff-note-label">Electrolytes</span>'+
        '<span class="ff-note-brand">'+kit.elec.vendor+'</span><span class="ff-note-name">'+kit.elec.name+'</span>'+
        '<div class="ff-note-body">One serving every 90 minutes ('+elecServings+' across the effort). Target '+plan.na+'mg sodium per hour. Take with water.</div>'+
      '</div></div>';
  }

  var preNote='';
  if(kit.pre&&dm>=90){
    var pi=PROD_CACHE[kit.pre.handle];
    preNote='<div class="ff-note-card">'+
      (pi&&pi.img?'<img class="ff-note-img" src="'+pi.img+'" alt="'+kit.pre.name+'" loading="lazy">':'<div class="ff-note-imgph">\uD83C\uDF5E</div>')+
      '<div class="ff-note-txt">'+
        '<span class="ff-note-label">Before you start</span>'+
        '<span class="ff-note-brand">'+kit.pre.vendor+'</span><span class="ff-note-name">'+kit.pre.name+'</span>'+
        '<div class="ff-note-body">2 to 3 hours before, alongside your normal breakfast. '+(dm>=180?'60 to 90g':'40 to 60g')+' of carbs, low fat, low fibre. Top up fluids.</div>'+
      '</div></div>';
  }

  var recNote='';
  if(kit.recovery&&dm>=60){
    var ri=PROD_CACHE[kit.recovery.handle];
    var prot=Math.round(plan.wt*0.3),rc=Math.round(plan.wt*0.8);
    recNote='<div class="ff-note-card recovery">'+
      (ri&&ri.img?'<img class="ff-note-img" src="'+ri.img+'" alt="'+kit.recovery.name+'" loading="lazy">':'<div class="ff-note-imgph">\uD83E\uDD5B</div>')+
      '<div class="ff-note-txt">'+
        '<span class="ff-note-label">After you finish</span>'+
        '<span class="ff-note-brand">'+kit.recovery.vendor+'</span><span class="ff-note-name">'+kit.recovery.name+'</span>'+
        '<div class="ff-note-body">Within 30 minutes: about '+prot+'g protein and '+rc+'g carbs. The recovery window closes fast.</div>'+
      '</div></div>';
  }

  var elecHours={};
  for(var k=1;k*90<=dm;k++){elecHours[Math.ceil((k*90)/60)]=true;}
  var hbhRows=timeline.map(function(hr){
    var body=hr.items.map(function(it){return (it.count>1?it.count+'\u00d7 ':'')+it.p.vendor+' '+it.p.name;}).join(' + ');
    if(elecHours[hr.h])body+=' + electrolyte';
    return '<div class="ff-hrow"><span class="ff-hrow-time">H'+hr.h+'</span><span class="ff-hrow-body">'+body+'</span><span class="ff-hrow-carb">'+hr.total+'g</span></div>';
  }).join('');
  var hbh='<details class="ff-hbh"><summary>See it hour by hour</summary>'+hbhRows+'</details>';

  var emailLines=['FUEL FIRST FUELLING PLAN','','Athlete: '+S.name+(S.lname?' '+S.lname:''),sportLabel()+' | '+plan.d+'km | '+plan.el+'m climbing | '+fmtM(dm),'','TARGETS','Carbs per hour: '+(plan.cp>0?plan.cp+'g':'Not required'),'Total carbs: '+(plan.tc>0?plan.tc+'g':'n/a'),'Fluid per hour: '+plan.fl+'ml','Sodium per hour: '+plan.na+'mg',''];
  phaseGroups.forEach(function(g){emailLines.push(single?'EACH HOUR':(phaseLabel[g.key]+' ('+rangeTxt(g.hours)+')').toUpperCase());g.items.forEach(function(it){emailLines.push('- '+(it.count>1?it.count+'x ':'')+it.p.vendor+' '+it.p.name+' ('+(it.count*it.p.carbs)+'g)');});emailLines.push('');});
  emailLines.push('At every aid station: refill bottle, water with your gel, restock pockets.');
  if(kit.elec&&elecServings>0)emailLines.push('- Electrolytes: '+kit.elec.vendor+' '+kit.elec.name+', 1 every 90 min');
  emailLines.push('Sip fluid every 20 minutes.');
  if(kit.pre&&dm>=90)emailLines.push('','BEFORE: '+kit.pre.vendor+' '+kit.pre.name+', 2 to 3 hours out.');
  if(kit.recovery&&dm>=60)emailLines.push('AFTER: '+kit.recovery.vendor+' '+kit.recovery.name+', within 30 min.');
  emailLines.push('','SHOPPING LIST');
  if(aidPct>0)emailLines.push('(Trimmed about '+aidPct+'% for aid station and real food. The plan above shows full intake.)');
  shop.forEach(function(i){emailLines.push('- '+i.vendor+' '+i.name+' x'+i.qty);});
  emailLines.push('','Based on GSSI and ACSM guidance. Always practise in training first.','','Powered by Fuel First. fuel-first.co.za');
  var mailto='mailto:'+encodeURIComponent(S.email)+'?subject='+encodeURIComponent('Your Fuel First Plan, '+fn)+'&body='+encodeURIComponent(emailLines.join('\n'));

  var cartRowsHTML=shop.map(function(i){
    var c=PROD_CACHE[i.handle];var varNum=c?c.variantNumId:null;
    var btnId='cart-atc-'+i.handle.replace(/[^a-z0-9]/g,'');
    var atc=varNum?'<button id="'+btnId+'" class="ff-atc-btn" onclick="addToCartShopify(\''+varNum+'\','+i.qty+',\''+btnId+'\')">Add \u00d7'+i.qty+'</button>':'<a href="'+STORE_URL+'/products/'+i.handle+'" target="_blank" style="font-size:11px;color:var(--orange)">View</a>';
    return '<div class="ff-cart-row"><span class="ff-cart-name"><strong style="color:var(--orange)">'+i.vendor+'</strong> '+i.name+'</span><span style="display:flex;align-items:center;gap:8px">\u00d7'+i.qty+atc+'</span></div>';
  }).join('');

  return topBar('Your Plan')+
  '<div class="ff-sec">'+
  '<span class="ff-result-label">Fuel First. '+fn+'\'s Plan</span>'+
  '<span class="ff-result-heading">'+sportLabel()+'</span>'+
  '<span class="ff-result-meta">'+plan.d+'km &middot; &uarr;'+plan.el+'m &middot; '+fmtM(dm)+(S.wx?' &middot; '+cap(S.wx):'')+(S.rg?' &middot; '+cap(S.rg):'')+(gpxData?' &middot; GPX':'')+'</span>'+
  '<div class="ff-hydration-bar">\uD83D\uDCA7 <strong>Hydration:</strong> aim for about '+Math.max(350,plan.fl-150)+' to '+plan.fl+'ml an hour, to thirst and heat, taken with sodium. Around '+Math.round(plan.fl*hrs)+'ml across the day.</div>'+
  '<div class="ff-stats">'+
    '<div class="ff-stat"><span class="ff-stat-val">'+(plan.cp>0?plan.cp+'g':'\u2014')+'</span><span class="ff-stat-lbl">Carbs/hr</span></div>'+
    '<div class="ff-stat"><span class="ff-stat-val">'+(plan.tc>0?plan.tc+'g':'\u2014')+'</span><span class="ff-stat-lbl">Total carbs</span></div>'+
    '<div class="ff-stat"><span class="ff-stat-val">'+plan.fl+'ml</span><span class="ff-stat-lbl">Fluid/hr</span></div>'+
    '<div class="ff-stat"><span class="ff-stat-val" style="font-size:15px;padding-top:4px">'+plan.na+'</span><span class="ff-stat-lbl">Sodium mg/hr</span></div>'+
  '</div>'+
  (alerts.length?alerts.map(function(a){return'<span class="ff-alert">'+a+'</span>';}).join(''):'')+
  '<span class="ff-section-head">'+(single?'Your Hourly Rhythm':'Your Fuelling Plan')+'</span>'+
  rhythm+aidNote+hbh+
  (shop.length?'<div class="ff-cart"><span class="ff-cart-title">\uD83D\uDED2 Your Shopping List</span>'+(aidPct>0?'<div class="ff-aid-bar" style="margin:0 0 12px">Trimmed for an effort this long. Real food and aid station snacks cover roughly '+aidPct+'% of your carbs, so you buy for the rest. The plan above still shows full hourly intake.</div>':'')+cartRowsHTML+'<button class="ff-cart-btn" onclick="goToCart()" style="margin-top:12px">Add All to Cart &rarr;</button></div>':'')+
  (elecNote?'<details class="ff-hbh" style="margin-top:8px"><summary>Electrolytes and salt</summary><div style="padding:6px 10px 10px">'+elecNote+'</div></details>':'')+
  ((preNote||recNote)?'<details class="ff-hbh" style="margin-top:8px"><summary>Before and after</summary><div style="padding:6px 10px 10px">'+preNote+recNote+'</div></details>':'')+
  '<details class="ff-hbh" style="margin-top:8px"><summary>How these numbers work</summary><div class="ff-disc" style="border-top:none;padding:10px 14px;margin:0">Carb targets follow GSSI and ACSM duration-based scaling, adjusted for climbing and capped at 90g per hour. Fluid is weight-based and adjusted for sweat rate and conditions. Sodium is a sweat-rate and temperature estimate. Always validate in training before race day.</div></details>'+
  '<div class="ff-cta-wrap">'+
    '<a href="'+mailto+'" class="ff-email-btn">&#9993;&nbsp; Email This Plan to Myself</a>'+
    '<a href="'+STORE_URL+'/collections/all" target="_blank" class="ff-shop-btn">Browse All Products &rarr;</a>'+
    '<button class="ff-rst" onclick="planReset()">Start a New Plan</button>'+
  '</div></div>';
}

var SCREENS={profile:Sprofile,sport:Ssport,goal:Sgoal,raceGoal:SraceGoal,gpx:Sgpx,distance:Sdistance,elevation:Selevation,time:Stime,conditions:Sconditions,sweat:Ssweat,fuelPrefs:SfuelPrefs,brands:Sbrands,caffeine:Scaffeine,dietary:Sdietary,stomach:Sstomach,results:Sresults};

var lastScr=-1;
function render(){
  var f=flow(),app=document.getElementById('ff-app');
  if(!app)return;
  var screen=f[S.scr];
  var nav=(S.scr!==lastScr);lastScr=S.scr;
  if(screen==='results'){
    app.innerHTML='<div style="text-align:center;padding:60px 0;color:var(--muted)"><div style="font-size:32px;margin-bottom:16px">\u26A1</div><div style="font-family:var(--font-display);font-size:14px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase">Building your plan\u2026</div></div>';
    if(nav&&S.scr>0)scrollCard();
    loadProductCache().then(function(){
      var app2=document.getElementById('ff-app');
      if(app2&&flow()[S.scr]==='results'){app2.innerHTML=Sresults();if(nav&&S.scr>0)scrollCard();}
    }).catch(function(){var app2=document.getElementById('ff-app');if(app2)app2.innerHTML=Sresults();});
    return;
  }
  if(screen==='brands'){
    if(CACHE_LOADED){app.innerHTML=Sbrands();if(nav&&S.scr>0)scrollCard();return;}
    app.innerHTML='<div style="text-align:center;padding:60px 0;color:var(--muted)"><div style="font-size:32px;margin-bottom:16px">\u26A1</div><div style="font-family:var(--font-display);font-size:14px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase">Loading brands\u2026</div></div>';
    if(nav&&S.scr>0)scrollCard();
    loadProductCache().then(function(){var a=document.getElementById('ff-app');if(a&&flow()[S.scr]==='brands'){a.innerHTML=Sbrands();if(nav&&S.scr>0)scrollCard();}}).catch(function(){var a=document.getElementById('ff-app');if(a)a.innerHTML=Sbrands();});
    return;
  }
  app.innerHTML=SCREENS[screen]();
  if(nav&&S.scr>0)scrollCard();
  if(gpxData&&screen==='gpx'){setTimeout(function(){drawElev(gpxData.elev);},50);}
}

function planReset(){
  S={scr:0,name:'',lname:'',email:'',wt:'',wu:'kg',age:'',gen:'',sport:'',goal:'',rg:'',gpx:null,dp:'',dc:'',elev:'',tH:3,tM:0,pace:'',spd:'',wx:'',sw:'',fp:[],cf:'',dt:[],st:'',brands:{}};
  gpxData=null;cartItems=[];render();
}

loadProductCache().catch(function(){});
render();